import ButtonLink from '../../../common/components/Button/ButtonLink.js'
import {FormattedRealDate} from '../../../common/components/FormattedDate.js'
import {AMAZON, MANUAL} from '../../../common/constants/CartVendorOptions.js'
import {formatDate, formatDateTimeAndZone} from '../../../common/date.js'

export function formatOrderDate(date, cartType) {
  return cartType === AMAZON
    ? {value: date, format: formatDate, timeZone: 'America/Los_Angeles'}
    : {value: date, format: formatDateTimeAndZone}
}

export default function ByDate({date, label, onClick, cartType}) {
  let dateElement = <FormattedRealDate {...formatOrderDate(date, cartType)} />

  if (cartType === MANUAL) {
    dateElement = (
      <ButtonLink className="v-align-base" onClick={onClick}>
        {date ? dateElement : <em>Add Date</em>}
      </ButtonLink>
    )
  }

  return (
    (date || cartType === MANUAL) && (
      <dd className="list__item--order-data">
        <strong className="margin-right-3">{label}:</strong>
        <span>{dateElement}</span>
      </dd>
    )
  )
}
